import React, {
  Component
} from "react";
import {
  withStyles
} from "@material-ui/core/styles";
import {
  connect
} from "react-redux";
import {
  withRouter,
  Redirect
} from "react-router-dom";
import ScrollToTopOnMount from "components/UI/ScrollToTopOnMount";
import Header from "components/Header/Header";
import BlockTitle from "components/UI/BlockTitle";
import Footer from "components/Footer";
import LoginForm from "./LoginForm";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import {
  isLoggedIn,
  getCurrentUserRole
} from "ducks/authentication";
import ResetPasswordRequestForm from "components/UI/ResetPassword/ResetPasswordRequestForm";
// import Banner from "components/Banner/Banner";
import i18n from "helpers/i18n";
import Container from "@material-ui/core/Container";
import Fade from "@material-ui/core/Fade";
import queryString from "query-string";
const styles = (theme) => {
  return {
    root: {
      minHeight: "100%",
      height: '100%',
      // display: "flex",
      // flexDirection: "column",
      // "& > *": {
      //   flex: 1,
      // },
    },
    header: {
      height: 150,
      [theme.breakpoints.down("sm")]: {
        height: 200
      }
    },
    content: {
      height: 'calc(100% - 150px - 60px)',
      minHeight: '580px',
      [theme.breakpoints.down("sm")]: {
        height: 'auto'
      }
    },
    footer: {
      height: 120,
      [theme.breakpoints.down("sm")]: {
        height: 'auto'
      }
    },
    paperWrapper: {
      width: '100%'
    },
    paper: {
      padding: theme.spacing(4),
    },
  };
};
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
    };
    this._onLoginPasswordReset = this._onLoginPasswordReset.bind(this);
    this._onRegistrationCancel = this._onRegistrationCancel.bind(this);
  }
  _onLoginPasswordReset() {
    this.setState({
      step: 3
    });
  }
  _onRegistrationCancel() {
    this.setState({
      step: 1
    });
  }
  render() {
    const {
      onPanelToggle,
      classes,
      userRole,
      isLoggedIn
    } = this.props;
    const {
      step
    } = this.state;
    if(isLoggedIn) {
      const uri = queryString.parse(window.location.search);
      const url = uri._pn !== undefined ? decodeURIComponent(uri._pn) : '/'
      return (<Redirect
          to={{
            pathname: url,
            state: { from: this.props.location },
          }}
          />);
    }
    return (<div className={classes.root}>
    <ScrollToTopOnMount/>
      <Header current={false} condensed={true}/>
      <div className={classes.content}>
            <ScrollToTopOnMount/>
            <Box py={4}>
            <Typography variant="h1" color="primary" align="center">{i18n.get('loginFormTitle')}</Typography>
            <Paper square elevation={0} className={classes.paper}>
              <If condition={step === 1}>
                <LoginForm
                  onFormComplete={this._onLoginFormComplete}
                  onPasswordResetRequest={this._onLoginPasswordReset}
                  showRequiredLegend={false}
                  />
              </If>
              <If condition={step === 3}>
                <ResetPasswordRequestForm
                  onFormCancel={this._onRegistrationCancel}
                  noTitle
                  />
              </If>
            </Paper>
          </Box>
    </div>
    <Footer style={{zIndex: 189, marginTop: -10}}/>
  </div>);
  }
}

function mapStateToProps(state) {
  const props = {
    userRole: getCurrentUserRole(state),
    isLoggedIn: isLoggedIn(state),
  };
  return props;
}
export default withStyles(styles)(withRouter(connect(mapStateToProps)(Login)));


// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx